import { css } from '@emotion/css';
import { Headline2 } from '@volumental/common';
import { type JSX } from 'react';

const containerStyle = css`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
`;

const boxContainerStyle = css`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  max-width: calc(50% - 9px);
`;

const imageContainerStyle = css`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-items: center;
  justify-self: center;
  align-self: center;
  justify-content: center;
  aspect-ratio: 1;
  overflow: hidden;
`;

const imageStyle = css`
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 1rem;
`;
const blobStyle = css`
  width: 100%;
  display: block;
  object-fit: cover;
  border-radius: 1rem;
  aspect-ratio: 1;
`;

interface ImageCompareBoxProps {
  mainImage: string;
  mainTitle: string;
  mainAlt: string;
  secondaryImage: string;
  secondaryTitle: string;
  secondaryAlt: string;
}

export function ImageCompareBox({
  mainImage,
  mainTitle,
  mainAlt,
  secondaryImage,
  secondaryTitle,
  secondaryAlt,
}: ImageCompareBoxProps): JSX.Element {
  return (
    <div className={containerStyle}>
      <div className={boxContainerStyle}>
        <Headline2>{mainTitle}</Headline2>
        <div className={imageContainerStyle}>
          <img src={mainImage} alt={mainAlt} className={imageStyle} />
        </div>
      </div>
      <div className={boxContainerStyle}>
        <Headline2>{secondaryTitle}</Headline2>
        <div className={imageContainerStyle}>
          <img src={secondaryImage} alt={secondaryAlt} className={blobStyle} />
        </div>
      </div>
    </div>
  );
}
